import React, { useMemo } from 'react'
import './ProductDetails.scss'
import Slider from '../slider/Slider'
import { RxExternalLink } from 'react-icons/rx'
import { TbBrandYoutube } from 'react-icons/tb'
import { formatPrice, hasValue } from '../../helpers'

export default function ProductDetails({
  product,
  slides,
  openProductMessageModal,
  onSlideImageClick,
  isMyCompany,
}) {
  const price = useMemo(() => {
    let formattedPrice = ''

    if (product.price_type === 'fixed') {
      formattedPrice = formatPrice(product.price)
    } else {
      const minFormattedPrice = formatPrice(product.min_price)
      const maxFormattedPrice = formatPrice(product.max_price)

      if (minFormattedPrice) {
        formattedPrice = minFormattedPrice
      }

      if (maxFormattedPrice) {
        formattedPrice = `${formattedPrice} - ${maxFormattedPrice}`
      }
    }

    return formattedPrice
  }, [product])

  return (
    <div className="product-details">
      <h3>{product.title}</h3>

      <div className="d-flex flex-column flex-sm-row">
        {slides?.length > 0 ? (
          <div className="slider-container mt-3 me-4">
            <Slider
              slides={slides}
              imgHeight={220}
              isImageClickable={true}
              onSlideImageClick={onSlideImageClick}
            />
          </div>
        ) : null}

        <div className="mt-3">
          {hasValue(price) ? <h3>{`${price} KM`}</h3> : null}

          {product.min_order_quantity ? (
            <div className=" mb-1">
              {`Min. narudžba: ${product.min_order_quantity} ${product.unit}`}
            </div>
          ) : null}

          {product.web_link ? (
            <div className="link mb-1">
              <a href={product.web_link} target="_blank">
                <RxExternalLink />
                <span>{`Web Link`}</span>
              </a>
            </div>
          ) : null}

          {product.youtube ? (
            <div className="link mb-1">
              <a href={product.youtube} target="_blank">
                <TbBrandYoutube />
                <span>{`YouTube`}</span>
              </a>
            </div>
          ) : null}

          {product.description ? (
            <div className="mt-4">
              <h5>{`Detaljno`}</h5>
              <p className="preserve-line-breaks">{product.description}</p>
            </div>
          ) : null}

          {isMyCompany ? null : (
            <button
              onClick={openProductMessageModal}
              className="btn btn-outline-primary">
              Poruka
            </button>
          )}
        </div>
      </div>
    </div>
  )
}
